import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close-light.svg'
import _imports_1 from '@/assets/img/logo-light.svg'


const _withScopeId = n => (_pushScopeId("data-v-53fa9ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-content" }
const _hoisted_2 = { style: {} }
const _hoisted_3 = { class: "float-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgmenu",
  src: _imports_0
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "menu-content-sec" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-separation" }, null, -1))
const _hoisted_8 = { class: "menu-content-sec3" }
const _hoisted_9 = { class: "menu-context-sec3-item" }
const _hoisted_10 = { class: "menu-context-sec3-item flex-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-separation" }, null, -1))
const _hoisted_12 = { class: "menu-content-sec4" }
const _hoisted_13 = { class: "menu-content-last" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_langpicker = _resolveComponent("langpicker")!
  const _component_v_runtime_template = _resolveComponent("v-runtime-template")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["right-top-menu", _ctx.showMenu ? 'width-280' : 'width-0'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.csrfLoaded || null)
          ? (_openBlock(), _createBlock(_component_langpicker, {
              key: 0,
              "is-mobile": true,
              class: "langpick-mobile",
              onLangChanged: _ctx.langChanged
            }, null, 8, ["onLangChanged"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
          }, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: "menu-content-sec1",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickSaveExit && _ctx.onClickSaveExit(...args)))
        }, _toDisplayString(_ctx.getUiText("app-prospect-menu-save-exit-1")), 1),
        _createElementVNode("span", {
          class: "menu-content-sec2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.myResponse && _ctx.myResponse(...args)))
        }, _toDisplayString(_ctx.getUiText("app-prospect-menu-review-responses-1")), 1),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_runtime_template, { template: _ctx.createAccountText }, null, 8, ["template"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.getUiText("app-prospect-menu-logout-text-1")) + " ", 1),
            _createElementVNode("a", {
              class: "menu-a-tag",
              href: "javascript:void(0)",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, _toDisplayString(_ctx.getUiText("app-prospect-menu-logout-link-1")), 1)
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (_ctx.csrfLoaded || null)
              ? (_openBlock(), _createBlock(_component_langpicker, {
                  key: 0,
                  class: "menu-content-sec4-item",
                  onLangChanged: _ctx.langChanged
                }, null, 8, ["onLangChanged"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("img", {
          class: "menu-content-last-img",
          src: _imports_1,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickLogo && _ctx.onClickLogo(...args)))
        })
      ])
    ])
  ], 2))
}